import axios from 'axios';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

/**
 * Real backend rejection reason for a boleta upload (too large, unreadable
 * format, decompression bomb, ...), or null when the response has no message.
 */
export function getBoletaUploadErrorMessage(error: unknown): string | null {
  if (!axios.isAxiosError(error) || !isRecord(error.response?.data)) {
    return null;
  }

  const message = error.response.data.message;
  if (typeof message === 'string' && message.trim().length > 0) {
    return message;
  }
  if (Array.isArray(message)) {
    const first = message.find(
      (entry): entry is string => typeof entry === 'string' && entry.trim().length > 0,
    );
    return first ?? null;
  }

  return null;
}
